import React, { createContext, useContext, useState } from "react";
import usePersistedState from "../hooks/usePersistedState";
import Client from "../utils/client";

const SwitchContext = createContext();

const SwitchProvider = ({ children }) => {
  const c = new Client();

  const [selectedSwitchTariff, setSelectedSwitchTariff] = usePersistedState(
    "selectedSwitchTariff",
    null
  );

  const [generatingSwitch, setGeneratingSwitch] = useState(false);
  const [showSwitchingFormErrorsAlert, setShowSwitchingFormErrorsAlert] = useState(true);
  const [showSwitchingError, setShowSwitchingError] = useState(false);

  const [fetchingValidationSchema, setFetchingValidationSchema] =
    useState(false);

  const [switchingFormData, setSwitchingFormData] = usePersistedState(
    "switchingFormData",
    {}
  );

  const setPriceId = (priceId) => {
    setSwitchingFormData((prev) => ({ ...prev, priceId }));
  };

  const getSwitchValidationSchema = async (switchMode = "acquisition") => {
    const supplierId = selectedSwitchTariff?.supplierId;
    if (supplierId) {
      setFetchingValidationSchema(true);
      const validationSchema = await c.switchValidationSchema(
        supplierId,
        switchMode
      );
      setFetchingValidationSchema(false);

      return validationSchema;
    }
  };

  const generateSwitch = async (data) => {
    setGeneratingSwitch(true);
    try {
      const switchRequest = await c.generateSwitch(data);
      setGeneratingSwitch(false);
      return switchRequest;
    } catch (error) {
      setShowSwitchingError(true);
      setGeneratingSwitch(false);
    }
  };

  const getSwitchStatus = async (switchId) => {
    try {
      const switchStatus = await c.switchStatus(switchId);
      return switchStatus;
    } catch (error) {
      console.log(error);
    }
  };

  const subscribeContactToEmail = async () => {
    const response = await c.subscribeContactToEmail();
    return response;
  }

  return (
    <SwitchContext.Provider
      value={{
        fetchingValidationSchema,
        generateSwitch,
        generatingSwitch,
        getSwitchStatus,
        getSwitchValidationSchema,
        selectedSwitchTariff,
        setPriceId,
        setSelectedSwitchTariff,
        setSwitchingFormData,
        switchingFormData,
        showSwitchingFormErrorsAlert,
        setShowSwitchingFormErrorsAlert,
        showSwitchingError,
        setShowSwitchingError,
        subscribeContactToEmail
      }}
    >
      {children}
    </SwitchContext.Provider>
  );
};

const useSwitch = () => {
  const context = useContext(SwitchContext);
  if (!context) {
    throw new Error("useSwitch must be used within a SwitchProvider");
  }
  return context;
};

export { SwitchContext, SwitchProvider, useSwitch };
